import { baseRequestHandler } from 'api/http-client/request-handler'

export function getLanguages() {
  return baseRequestHandler.get('languages')
}
